import React from 'react'
import { logOutUser } from '../routes/login/reducers/loginReducer'
import * as Sentry from '@sentry/browser'


export const handleErrorAndGenerateMessage = (error, module, dispatch) => {
  if (error && !error.response) {
    Sentry.captureException(error)
    return "The server is temporarily down. Please try again."
  }

  if (error && error.response && error.response.status === 401) {
    const message = 'Your session has expired. Please log back in.'
    if (dispatch && typeof dispatch === 'function') {
      dispatch(logOutUser(message))
    }
    return message
  }

  if (error && error.response && error.response.status === 404) {
    return 'Error: Object or path not found on server'
  }

  if (error && error.response && error.response.data && Array.isArray(error.response.data)) {
    return (
      <div>
        <p>
          The following errors occurred:
        </p>

        {Object.keys(error.response.data).map(key => {
          return (
            <p key={key}>
              {key.split('_').join(' ')}: {error.response.data[key].join(' ')}
            </p>
          )
        })}
      </div>
    )
  }

  if (error && error.response && error.response.data && error.response.data.non_field_errors && Array.isArray(error.response.data.non_field_errors)) {
    return (
      <div>
        <p>
          The following errors occurred:
        </p>

        {error.response.data.non_field_errors.map(error => {
          return (
            <p key={error}>
              {error}
            </p>
          )
        })}
      </div>
    )
  }

  if (error && error.response && error.response.data && error.response.data.message) {
    return error.respones.data.message
  }

  return `There was an error with ${module}. Please try again.`
}
